import useTypedTranslation from "@shared/common/i18n/useTypedTranslation.ts";
import { LanguageNameSpaces } from "@shared/types";
import {
  ALL_CATEGORIES,
  CATEGORY_TO_LABEL,
  EXPENSE_CATEGORIES,
  INCOME_CATEGORIES,
} from "features/finance/constants";
import { FinanceCategory, FinanceDirection } from "features/finance/types";

const useCategoryOptions = (direction?: FinanceDirection) => {
  const { t } = useTypedTranslation(LanguageNameSpaces.ADMIN);
  let categories: FinanceCategory[] = ALL_CATEGORIES;
  if (direction === FinanceDirection.INCOME)
    categories = [...INCOME_CATEGORIES, FinanceCategory.OTHER];
  else if (direction === FinanceDirection.EXPENSE)
    categories = EXPENSE_CATEGORIES;
  return categories.map((category) => ({
    value: category,
    label: t(CATEGORY_TO_LABEL[category]),
  }));
};

export default useCategoryOptions;
